<template>
<div class="d-flex py-2 py-md-3 footer-control justify-content-between " :class="footerNavigationClass">
  <template v-if="$route.name == 'Brand' || $route.name == 'Type'">
    <b-button variant="outline-dark" v-if="isMobile().phone" size="sm" class="mx-3" pill @click="clickDoubleUp">
      <b-icon-chevron-double-up></b-icon-chevron-double-up>
    </b-button>
    <div v-else style="width: 145px;">
      &nbsp;
    </div>
  </template>
  <div v-else>
    &emsp;
  </div>

  <div>
    <b-button variant="outline-dark" class="mx-3" :size="isMobile().phone? 'sm': ''" pill :disabled="isUpButtonDisabled" @click="clickUpButton">
      <b-icon-chevron-up></b-icon-chevron-up>
    </b-button>
    <b-button variant="outline-dark" class="mx-3" :size="isMobile().phone? 'sm': ''" pill :disabled="isDownButtonDisabled" @click="clickDownButton">
      <b-icon-chevron-down></b-icon-chevron-down>
    </b-button>
  </div>

  <div>
    <template v-if="$route.name == 'Brand' || $route.name == 'Type'">
      <b-button variant="outline-dark" v-if="!isMobile().phone" class="mx-3" pill @click="clickDoubleUp">
        <b-icon-chevron-double-up></b-icon-chevron-double-up>
      </b-button>
      <b-button variant="outline-dark" :size="isMobile().phone? 'sm': ''" class="mx-3" pill :disabled="brandNavigationShowing || typeNavigationShowing" @click="scrollLeft">
        <b-icon-chevron-double-left></b-icon-chevron-double-left>
      </b-button>
    </template>
  </div>

</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import isMobile from 'ismobilejs'

export default {
  data() {
    return {
      isMobile
    }
  },
  computed: {
    ...mapState({
      currentPage: state => state.currentPage,
      brands: state => state.brands,
      brandArrayIndex: state => state.brandArrayIndex,
      brandNavigationShowing: state => state.brandNavigationShowing,
      brandMobileP2Showing: state => state.brandMobileP2Showing,
      types: state => state.types,
      typeArrayIndex: state => state.typeArrayIndex,
      typeNavigationShowing: state => state.typeNavigationShowing,
      typeMobileP2Showing: state => state.typeMobileP2Showing,
      libraryIndexes: state => state.libraryIndexes,
      selectedLibraryIndex: state => state.selectedLibraryIndex
    }),
    isUpButtonDisabled() {
      if (this.$route.name === 'Home') {
        if (this.currentPage == 3) {
          if (this.brandMobileP2Showing) {
            return false
          }
        } else if (this.currentPage == 4) {
          if (this.typeMobileP2Showing) {
            return false
          }
        } else if (this.currentPage == 5) {
          // Library
          if (this.libraryIndexes) {
            if (this.libraryIndexes[0].id == this.selectedLibraryIndex) {
              return true
            }
          }
          return false
        }
        return true
      }
      return false
    },
    isDownButtonDisabled() {
      if (this.$route.name === 'Home') {
        if (this.currentPage == 3) {
          if (this.brandMobileP2Showing) {
            return true
          }
        } else if (this.currentPage == 4) {
          if (this.typeMobileP2Showing) {
            return true
          }
        } else if (this.currentPage == 5) {
          // Library
          if (this.libraryIndexes) {
            if (this.libraryIndexes[this.libraryIndexes.length - 1].id == this.selectedLibraryIndex) {
              return true
            }
          }
        }
      } else if (this.$route.name === 'Information') {
        return true
      } else if (this.$route.name === 'Brand') {
        if (this.brandArrayIndex == this.brands.length -1) {
          return true
        }
      } else if (this.$route.name === 'Type') {
        if (this.typeArrayIndex == this.types.length -1) {
          return true
        }
      }
      return false      
    },
    canScrollLeft() {
      return false
    },
    footerNavigationClass() {
      if (this.$route.name == 'Home') {
        if (isMobile().phone) {
          if (!(this.currentPage == 3 || this.currentPage == 4 || this.currentPage == 5)) {
            return 'fadeout'
          }
        } else {
          if (!(this.currentPage == 3 || this.currentPage == 4 || this.currentPage == 5 || this.currentPage == 6)) {
            return 'fadeout'
          }
        }
      } else if (isMobile().phone) {
        if (this.brandNavigationShowing || this.typeNavigationShowing) {
          return 'fadeout'
        }
      } 
      return ''
    }
  },
  methods: {
    ...mapActions({
      updateScrollLeftTrigger: 'doUpdateScrollLeftTrigger',
      setBrandMobileP2Showing: 'doSetBrandMobileP2Showing',
      setTypeMobileP2Showing: 'doSetTypeMobileP2Showing',
      setSelectedLibraryIndex: 'doSetSelectedLibraryIndex'
    }),

    clickUpButton() {
      if (this.$route.name === 'Home') {
        if (this.currentPage == 3) {
          if (this.brandMobileP2Showing) {
            this.setBrandMobileP2Showing(false)
          }
        } else if (this.currentPage == 4) {
          if (this.typeMobileP2Showing) {
            this.setTypeMobileP2Showing(false)
          }
        } else if (this.currentPage == 5) {
          // library
          // 1個下のlibraryIndexを選択
          let ii = 0
          for (let i=0; i<this.libraryIndexes.length; i++ ) {
            if (this.libraryIndexes[i].id == this.selectedLibraryIndex) {
              ii = i
              break
            }
          }
          this.setSelectedLibraryIndex(this.libraryIndexes[ii-1].id)
        }
      } else if (this.$route.name === 'Information') {
          this.$router.push({name: 'Home', hash: '#information'})
      } else if (this.$route.name === 'Brand') {
        if (this.brandArrayIndex == 0) {
          // TOPページのBrandセクションに戻る
          this.$router.push({name: 'Home', hash: '#brand'})
        } else {
          // 1こ前のBrand詳細ページ
          this.$router.push({path: '/brand/' + (parseInt(this.brandArrayIndex) - 1)})
        }
      } else if (this.$route.name === 'Type') {
        if (this.typeArrayIndex == 0) {
          // TOPページのTypeセクションに戻る
          this.$router.push({name: 'Home', hash: '#type'})
        } else {
          // 1こ前のType詳細ページ
          this.$router.push({path: '/type/' + (parseInt(this.typeArrayIndex) - 1)})
        }
      }
    },
    clickDownButton() {
      if (this.$route.name === 'Home') {
        if (this.currentPage == 3) {
          if (isMobile().phone) {
            // ブランドリストを1画面ぶんスクロール
            this.setBrandMobileP2Showing(true)
          } else {
            // 1個めのBrandに移動
            this.$router.push({path: '/brand/0'})
          }
        } else if (this.currentPage == 4) {
          if (isMobile().phone) {
            // ブランドリストを1画面ぶんスクロール
            this.setTypeMobileP2Showing(true)
          } else {
            // 1個めのTypeに移動
            this.$router.push({path: '/type/0'})
          }
        } else if (this.currentPage == 5) {
          // library
          // 1個下のlibraryIndexを選択
          let ii = 0
          for (let i=0; i<this.libraryIndexes.length; i++ ) {
            if (this.libraryIndexes[i].id == this.selectedLibraryIndex) {
              ii = i
              break
            }
          }
          this.setSelectedLibraryIndex(this.libraryIndexes[ii+1].id)
        } else if (this.currentPage == 6) {
          this.$router.push({name: 'Information'})
        }
      } else if (this.$route.name === 'Brand') {
        // 次のページへ行く
        this.$router.push({path: '/brand/' + (parseInt(this.brandArrayIndex) + 1)})
      } else if (this.$route.name === 'Type') {
        // 次のページへ行く
        this.$router.push({path: '/type/' + (parseInt(this.typeArrayIndex) + 1)})
      }
    },
    clickDoubleUp() {
      if (this.$route.name === 'Brand') {
        this.setBrandMobileP2Showing(false)
        this.$router.push({name: 'Home', hash: '#brand'})
      } else if (this.$route.name === 'Type') {
        this.setTypeMobileP2Showing(false)
        this.$router.push({name: 'Home', hash: '#type'})
      }
    },
    scrollLeft() {
      this.updateScrollLeftTrigger()
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-control {
  position: absolute;
  background-color: #fff;
  @media screen and (min-width: 768px) {
    background-color: transparent;
  }
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 20;
  transition: opacity 0.6s;
  opacity: 1;
  &.fadeout {
    opacity: 0;
    pointer-events: none;
  }
}
</style>